import * as R from 'ramda';

export enum DataMode {
  NORMAL,
  MEAN,
  ABS_MEAN,
  REL_MEAN,
  Z_SCORE,
  TREND,
  RELATIVE_TREND
  // RANK
};

// const REL_MEAN_CLASSES=[0,25,50,75,90,100,110,125,150,175,200,null];
const REL_MEAN_CLASSES=[0,25,33,50,75, 90,110,125,150,200,400,null];

export const DATA_MODE_CLASSES:{[key in keyof typeof DataMode]?:number[]} = {
  [DataMode.REL_MEAN]:REL_MEAN_CLASSES,
  [DataMode.Z_SCORE]:[null,-4,-3,-2,-1,-0.5,0.5,1,2,3,4,null],
  [DataMode.RELATIVE_TREND]:[null,-5,-2,-1,-0.5,-0.25,0.25,0.5,1,2,5,null]
};

export const DATA_MODE_LABELS:{[key in keyof typeof DataMode]?:string} = {
  [DataMode.ABS_MEAN]:'compared to',
  [DataMode.REL_MEAN]:'as a proportion of',
  [DataMode.MEAN]:'Long term average',
  [DataMode.Z_SCORE]:'compared to',
  [DataMode.TREND]:'Trend over time of',
  [DataMode.RELATIVE_TREND]:'Relative Trend over time of'
};

export const DATA_MODE_COMPARISON_ONLY:{[key in keyof typeof DataMode]?:boolean} = {
  [DataMode.MEAN]:true,
  [DataMode.TREND]:true,
  [DataMode.RELATIVE_TREND]:true
};

export const DATA_MODE_TRENDS:{[key in keyof typeof DataMode]?:boolean} = {
  [DataMode.TREND]:true,
  [DataMode.RELATIVE_TREND]:true
};

export const DATA_MODE_SUFFIXES:{[key in keyof typeof DataMode]?:string} = {
  [DataMode.Z_SCORE]:', calculated in number of standard deviations (σ)',
  [DataMode.RELATIVE_TREND]: ', compared to the period mean'
}

export const DATA_MODE_INVALID_FOR_NEGATIVE_VALUES:{[key in keyof typeof DataMode]?:boolean} = {
  [DataMode.REL_MEAN]: true,
  [DataMode.RELATIVE_TREND]: true
};

export const TITLE_UNITS:{[key in keyof typeof DataMode]?:string} = {
  [DataMode.Z_SCORE]:'z-score'
}

export const LEGEND_UNITS:{[key in keyof typeof DataMode]?:string} = {
  [DataMode.REL_MEAN]:'%',
  [DataMode.RELATIVE_TREND]:'%',
  [DataMode.Z_SCORE]:'σ'
};

export const LEGEND_PRECISION:{[key in keyof typeof DataMode]?:number} = {
  [DataMode.Z_SCORE]:2
}

export const ANOMALY_PALETTE_NAME = 'RdBu';
export const ANOMALY_PALETTE_COUNT = 11;
export const ANOMALY_PALETTE = `${ANOMALY_PALETTE_NAME}_${ANOMALY_PALETTE_COUNT}`;

export const DATA_MODE_NAMES:{[key in keyof typeof DataMode]?:string} = {
  [DataMode.NORMAL]:'Normal',
  [DataMode.MEAN]:'Long-term average',
  [DataMode.ABS_MEAN]:'Difference from mean',
  [DataMode.REL_MEAN]:'Percentage of mean',
  [DataMode.Z_SCORE]:'Z Score',
  [DataMode.TREND]:'Trend',
  [DataMode.RELATIVE_TREND]:'Relative Trend'
};

export const DATA_MODE_INVERSE_LABELS = Object.keys(DATA_MODE_NAMES).map(k=>({[DATA_MODE_NAMES[k as any as DataMode]]:(+k) as DataMode})).reduce((a,b)=>({...a,...b}),{});

// export const DATA_MODES:{mode:keyof typeof DataMode,label:string}[]= Object.values(R.mapObjIndexed((mode,label)=>({mode,label}),LABELS));

